// extracted by mini-css-extract-plugin
export default {"Backdrop":"Backdrop_Backdrop__2qp5+"};